module.exports = __webpack_public_path__ + "restore.jpg?aacdb1c2782808e7d9b7f4cca7ce09c2";


//////////////////
// WEBPACK FOOTER
// ./src/images/restore.jpg
// module id = 145
// module chunks = 0